import $ from 'jquery';
import notifications from './notifications.js';
import { eventType } from './config/settings.js';
import { setNavigationCookies } from './store/cookies.js';
import { push } from './store/history.js';
import utils from './utils.js';
import core from './payment/common/lib/core.js';
import { fetchJson } from './core/ajax-json.js';
import currencyFormatter from './libs/currency-formatter.js';
import { getLocale } from './libs/locale.js';

const $pusher = $('.pusher');
const $offerContainer = $('.shop-detail');
const $shopContainer = $pusher.find('.shop');
const $getBonusButton = $offerContainer.find('.js-btn-bonus-get');
const $getBonusButtonSpinner = $getBonusButton.find('.spinner');
const $voucherContainer = $('.shop__voucher-container');
const $voucherInputButton = $voucherContainer.find('.btn-voucher-code-input');
const $bonusDetail = $('.accordion');
const $bonusDetailContent = $('.accordion__content');
const $headerWrapperShop = $offerContainer.find('.header-wrapper');
const $pageHeadOfferShop = $offerContainer.find('.page-head');
const $pageHeadShop = $pusher.find('.page-head');
const prevScrollPos = [0, 0];
const needsMobVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_MOBILE';
let textkeysObj = [];
let lastCheckedBonusType = '';
let lastCheckedBonusId = '';
let lastCheckedBonusPaymentMethods = '';

function clearBonusDetails() {
	$offerContainer.find('#shop-bonus-title').html('');
	$offerContainer.find('#shop-bonus-type').html('');
	$offerContainer.find('#shop-bonus-header').html('');
	$offerContainer.find('#shop-bonus-description').html('');
	$offerContainer.find('#shop-bonus-valid-products').html('');
	$offerContainer.find('#shop-bonus-days-to-play').html('');
	$offerContainer.find('#shop-bonus-expiry-date').html('');
	$offerContainer.find('#shop-bonus-min-deposit').html('');
	$offerContainer.find('#shop-bonus-max-deposit').html('');
	$offerContainer.find('#shop-bonus-percentage').html('');
	$offerContainer.find('#shop-bonus-amount').html('');
	$offerContainer.find('#bonus-casino-x-factor').html('');
	$offerContainer.find('#bonus-sports-x-factor').html('');
	$offerContainer.find('#bonus-sports-minimum-odds').html('');
	$offerContainer.find('#bonus-sports-minimum-selections').html('');
	$offerContainer.removeAttr('data-bonus-type');
}

function setCommonFields($bonusContainer) {
	// Setting common fields
	$offerContainer.find('#shop-bonus-title').html($bonusContainer.data('bonus-title'));
	$offerContainer.attr('data-bonus-type', $bonusContainer.data('bonus-title'));
	$offerContainer.find('#shop-bonus-type').html($bonusContainer.data('text-bonus-title'));
	const bonusTag = $bonusContainer.find('.u-dib').clone();
	$offerContainer.find('.u-dib').replaceWith(bonusTag);
	$offerContainer.find('#shop-bonus-image').attr('src', $bonusContainer.data('bonus-image'));
	$offerContainer.find('#shop-bonus-header-title').html($bonusContainer.data('bonus-header'));
	$offerContainer.find('#shop-bonus-header-description').html($bonusContainer.data('bonus-header'));
	$offerContainer.find('#shop-bonus-description').html($bonusContainer.data('bonus-description'));
	$offerContainer.find('#shop-bonus-valid-products').html($bonusContainer.data('bonus-valid-products'));
	$offerContainer.find('#shop-bonus-days-to-play').html(parseInt($bonusContainer.data('bonus-days-to-play'), 10));
	$offerContainer.find('#shop-sports-bonus-requirements').show();
	$offerContainer.find('#shop-casino-bonus-requirements').show();
}

function populateDepositBonusDetails($bonusContainer) {
	$offerContainer.find('#shop-bonus-amount').parent().hide();
	$offerContainer.find('#shop-bonus-percentage').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').parent().show();
	$offerContainer.find('#shop-bonus-min-deposit').parent().show();
	$offerContainer.find('#shop-bonus-max-deposit').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').html($bonusContainer.data('bonus-expiry-date'));
	fetchJson('/player/currency')
		.then((response) => {
			const currencyIsoCode = response.result;
			$offerContainer.find('#shop-bonus-min-deposit').html(currencyFormatter.format($bonusContainer.data('bonus-min-deposit'), currencyIsoCode, getLocale()));
			$offerContainer.find('#shop-bonus-max-deposit').html(currencyFormatter.format($bonusContainer.data('bonus-max-deposit'), currencyIsoCode, getLocale()));
			$offerContainer.find('#shop-bonus-percentage').html($bonusContainer.data('bonus-percentage'));
			if ($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0) {
				if (!($bonusContainer.data('sports-x-factor') && (parseFloat($bonusContainer.data('sports-x-factor')) > 0) &&
					(parseFloat($bonusContainer.data('minimum-odds')) > 0) && (parseFloat($bonusContainer.data('minimum-selections')) > 0))) {
					$offerContainer.find('#shop-sports-bonus-requirements').hide();
				}
				$offerContainer.find('#bonus-casino-x-factor').html(`${$bonusContainer.data('casino-x-factor')}x ${$bonusContainer.data('casino-bonus-x-factor-suffix')}`);
			}
			if ($bonusContainer.data('sports-x-factor') && (parseFloat($bonusContainer.data('sports-x-factor'))) > 0 &&
				(parseFloat($bonusContainer.data('minimum-odds')) > 0) && (parseFloat($bonusContainer.data('minimum-selections')) > 0)) {
				if (!($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0)) {
					$offerContainer.find('#shop-casino-bonus-requirements').hide();
				}
				$offerContainer.find('#bonus-sports-x-factor').html(`${$bonusContainer.data('sports-x-factor')}x ${$bonusContainer.data('sports-bonus-x-factor-suffix')}`);
				$offerContainer.find('#bonus-sports-minimum-odds').html($bonusContainer.data('minimum-odds'));
				$offerContainer.find('#bonus-sports-minimum-selections').html(parseInt($bonusContainer.data('minimum-selections'), 10));
			}
		});
}

function populateFreeMoneyBonusDetails($bonusContainer) {
	// hiding fields specific to deposit bonus and displaying fields for free money bonus
	$offerContainer.find('#shop-bonus-percentage').parent().hide();
	$offerContainer.find('#shop-bonus-min-deposit').parent().hide();
	$offerContainer.find('#shop-bonus-max-deposit').parent().hide();
	$offerContainer.find('#shop-bonus-expiry-date').parent().show();
	$offerContainer.find('#shop-bonus-amount').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').html($bonusContainer.data('bonus-expiry-date'));
	$offerContainer.find('#shop-bonus-min-deposit').html($bonusContainer.data('bonus-expiry-date'));
	fetchJson('/player/currency')
		.then((response) => {
			const currencyIsoCode = response.result;
			$offerContainer.find('#shop-bonus-amount').html(currencyFormatter.format($bonusContainer.data('bonus-amount-value'), currencyIsoCode, getLocale()));
			if ($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0) {
				if (!($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0)) {
					$offerContainer.find('#shop-sports-bonus-requirements').hide();
				}
				$offerContainer.find('#bonus-casino-x-factor').html(currencyFormatter.format($bonusContainer.data('casino-x-factor'), currencyIsoCode, getLocale()));
			}
			if ($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0) {
				if (!($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0)) {
					$offerContainer.find('#shop-casino-bonus-requirements').hide();
				}
				$offerContainer.find('#bonus-sports-x-factor').html(`${$bonusContainer.data('sports-x-factor')}x ${$bonusContainer.data('sports-bonus-x-factor-suffix')}`);
				$offerContainer.find('#bonus-sports-minimum-odds').html($bonusContainer.data('minimum-odds'));
				$offerContainer.find('#bonus-sports-minimum-selections').html(parseInt($bonusContainer.data('minimum-selections'), 10));
			}
		});
}

function hideDetailsForCashBonus() {
	$offerContainer.find('#shop-bonus-expiry-date').parent().hide();
	$offerContainer.find('#shop-bonus-amount').parent().parent().parent().hide();
	$offerContainer.find('#shop-casino-bonus-requirements').parent().parent().hide();
}
function showDetailsForNonCashBonus() {
	$offerContainer.find('#shop-bonus-amount').parent().parent().parent().show();
	$offerContainer.find('#shop-casino-bonus-requirements').parent().parent().show();
}

function populateBonusDetails($bonusContainer) {
	// Clearing any preset field
	clearBonusDetails();
	setCommonFields($bonusContainer);

	/* hiding fields specific to free money bonus and displaying fields for deposit bonus
	   Bonus Requirement handling for deposit bonuses is different from Free money bonuses. Hence, we use different conditions */
	if ($bonusContainer.data('bonus-title') === 'DepositBonus') {
		populateDepositBonusDetails($bonusContainer);
		lastCheckedBonusType = 'DepositBonus';
	} else {
		populateFreeMoneyBonusDetails($bonusContainer);
		lastCheckedBonusType = 'FreeMoneyBonus';
	}
	if ($bonusContainer.data('bonus-title') === 'CashBonus') {
		hideDetailsForCashBonus();
	} else {
		showDetailsForNonCashBonus();
	}
	$offerContainer.find('.js-btn-bonus-get').attr('data-bonus-id', $bonusContainer.data('bonus-id'));
	$offerContainer.find('.js-btn-bonus-get').attr('data-payment-methods', $bonusContainer.data('payment-methods'));
	lastCheckedBonusId = $bonusContainer.data('bonus-id');
	lastCheckedBonusPaymentMethods = $bonusContainer.data('payment-methods');
}

function openDetail() {
	$shopContainer.find('.shop-item').on('click', function () {
		// save the previous scroll position
		prevScrollPos[0] = window.scrollX;
		prevScrollPos[1] = window.scrollY;
		populateBonusDetails($(this));
		$offerContainer.addClass('shop-detail--open');
		document.querySelector('.pusher').classList.toggle('u-lock-parent-view');
		// scroll to top to make sure we show the title
		window.scrollTo(0, 0);
		// Remove transform so that position: fixed will work within this area
		setTimeout(() => {
			$offerContainer.addClass('u-transform-none');
		}, 300);
	});
}

function openShopItem(itemId) {
	const $item = $shopContainer.find(`[bonus-id='${itemId}']`);
	if ($item.length > 0) {
		$item.trigger('click');
	} else {
		console.error(`shop item not found for id: ${itemId}`);
	}
}

function getOpenedShopItem() {
	$getBonusButton.trigger('click');
}


function closeDetailAction() {
	if ($offerContainer) {
		$offerContainer.removeClass('u-transform-none').removeClass('shop-detail--open');
		$pusher.removeClass('u-lock-parent-view');
		window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
	}
}

function closeDetail() {
	$offerContainer.find('.icon-close').on('click', () => {
		// Put back transform so that we can close this view
		closeDetailAction();
	});
}

function removeBonusFromShop(bonusId) {
	if ($shopContainer) {
		$shopContainer.find('.shop-item').each(function () {
			if (parseInt($(this).data('bonus-id'), 10) === bonusId) {
				$(this).hide();
			}
		});
	}
}

function redeemVoucher(voucherCode) {
	const data = {
		string: voucherCode
	};
	$.ajax({
		url: '/bonus/redeemvoucher',
		type: 'POST',
		data: JSON.stringify(data),
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function response(resultData) {
		if (resultData.status === 'SUCCESS') {
			const result = JSON.parse(resultData.result);
			notifications.showInformationMessage('success', result.headerText, result.message);
			if (result.isFreeMoneyConditional === true || result.isDepositBonus === true) {
				setTimeout($.proxy(() => {
					location.reload();
				}, this), 3500);
			}
		}
		if (resultData.status === 'FAILURE') {
			notifications.showNotification(resultData.errorDescription, 'red', true);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function openMobileVerNotification(notificationText) {
	const pushToMobileVerify = function () {
		push('/account/mysettings/verify-mobile/', { bonusId: lastCheckedBonusId, referrer: 'shop' });
	};
	notifications.showBinaryQuestion(notificationText, textkeysObj['verify-mobile'], textkeysObj['not-now'], pushToMobileVerify, notifications.hideNotification);
}
function redeemFreeMoneyBonus(bonusId) {
	const data = {
		value: bonusId
	};
	$.ajax({
		url: '/bonus/redeemfreemoneybonus',
		type: 'POST',
		data: JSON.stringify(data),
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			closeDetailAction();
			const result = JSON.parse(resultData.result);
			// showInformationMessage(type, titleText, messageText, effect)
			notifications.showInformationMessage('success', result.headerText, result.message, null, -1);
			removeBonusFromShop(bonusId);
		}

		if (resultData.status === 'FAILURE') {
			closeDetailAction();
			if (resultData.errorCode === needsMobVerErrCode) {
				openMobileVerNotification(resultData.errorDescription);
			} else {
				notifications.showNotification(resultData.errorDescription, 'red', true);
			}
			console.error(`FAILURE:${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	}).always(() => {
		$getBonusButtonSpinner.addClass('u-hide');
	});
}

function redeemDepositBonus(bonusId, bonusPaymentMethods) {
	notifications.hideNotification();

	$.ajax({
		url: '/bonus/isDepositBonusOK',
		type: 'GET',
		//contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			closeDetailAction();
			push(`/account/deposit/shoppayment?referrer=shop&bonusId=${bonusId}&bonusPaymentMethods=${bonusPaymentMethods}`);
		}

		if (resultData.status === 'FAILURE') {
			closeDetailAction();
			if (resultData.errorCode === needsMobVerErrCode) {
				openMobileVerNotification(resultData.errorDescription);
			} else {
				notifications.showNotification(resultData.errorDescription, 'red', true);
			}
			console.error(`FAILURE:${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).always(() => {
		$getBonusButtonSpinner.addClass('u-hide');
	});
}

function setupClickHandlers() {
	$getBonusButton.on(eventType, function (e) {
		e.stopPropagation();
		e.preventDefault();
		$getBonusButtonSpinner.removeClass('u-hide');
		const bonusType = lastCheckedBonusType;
		const bonusId = lastCheckedBonusId;
		const bonusPaymentMethods = lastCheckedBonusPaymentMethods || 'ALL';
		if (bonusType === 'FreeMoneyBonus') {
			redeemFreeMoneyBonus(bonusId);
		} else if (bonusType === 'DepositBonus') {
			redeemDepositBonus(bonusId, bonusPaymentMethods);
		}
	});

	$voucherInputButton.on(eventType, function (e) {
		e.stopPropagation();
		e.preventDefault();
		const voucherCode = $(this).parent().find('.input-wrap__input').val()
			.trim();
		redeemVoucher(voucherCode);
	});
}

function toggleBonusDetails() {
	$bonusDetail.find('.js-bonus-detail-wrapper__link').on('click', (event) => {
		event.preventDefault();
		$bonusDetail.toggleClass('accordion--is-open');
		$bonusDetailContent.toggleClass('u-hide');
	});
}

function getAvailableBonuses() {
	$.ajax({
		url: '/bonus/availablebonuses',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			const jsonStr = JSON.stringify(resultData.result.list);
			console.info(`Available bonuses: ${jsonStr}`);
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}


function getAvailableBonusesOnRegistration() {
	$.ajax({
		url: '/bonus/availablebonusesonregistration',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			const jsonStr = JSON.stringify(resultData.result.list);
			console.info(`Available bonuses on registration: ${jsonStr}`);
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function getDepositBonuses() {
	$.ajax({
		url: '/bonus/depositbonuses',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {
			const jsonStr = JSON.stringify(resultData.result.list);
			console.info(`Available bonuses: ${jsonStr}`);
		}
		if (resultData.status === 'FAILURE') {
			console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function setUpScrollHandlers() {
	$offerContainer.scroll(() => {
		$headerWrapperShop.find('img').css('opacity', 1 - ($(window).scrollTop() / 200));
	});

	const changeHeaderWhenScroll = utils.debounce(() => {

		if ($offerContainer.scrollTop() > 0) {
			$headerWrapperShop.find('.header__title').addClass('header__title--hide');
		} else {
			$headerWrapperShop.find('.header__title').removeClass('header__title--hide');
		}
		if ($offerContainer.scrollTop() > 25) {
			$pageHeadOfferShop.addClass('page-head--opac');
			$pageHeadOfferShop.find('.page-head__title').addClass('page-head--opac');
			$pageHeadShop.addClass('page-head--opac');
		} else {
			$pageHeadOfferShop.removeClass('page-head--opac');
			$pageHeadOfferShop.find('.page-head__title').removeClass('page-head--opac');
			$pageHeadShop.removeClass('page-head--opac');
		}
	}, 100);

	$offerContainer.scroll(changeHeaderWhenScroll);
}

function init() {
	setNavigationCookies('shop');
	openDetail();
	closeDetail();
	setupClickHandlers();
	toggleBonusDetails();
	setUpScrollHandlers();
	textkeysObj = core.getTextkeysFromElement(document.getElementById('js-textkeys-depositflow'));
}

const shop = {
	openShopItem,
	getOpenedShopItem,
	getAvailableBonuses,
	getAvailableBonusesOnRegistration,
	getDepositBonuses,
	closeDetailAction,
	removeBonusFromShop,
	init
};

export default shop;



// WEBPACK FOOTER //
// ./mobile-core/src/shop.js